import { useEffect, useState } from 'react';

import { parseURLSearchParams, pushParamsToHistory } from '../../url-utils/url-params';

interface ParamsState {
  params: Record<string, string>;
}

export const useParams = () => {
  const [params, setParams] = useState<ParamsState>({
    params: parseURLSearchParams(),
  });

  useEffect(() => {
    const onPopstate = () => {
      setParams({ params: parseURLSearchParams() });
    };
    window.addEventListener('popstate', onPopstate);
    return () => {
      window.removeEventListener('popstate', onPopstate);
    };
  }, []);

  return {
    ...params,
    pushParamsToHistory,
  };
};
